export const formatCheckClearingLabel = (value: string | number | null | undefined): string => {
  const clearing = Number(value);
  if (clearing === 1) return '24 hs';
  if (clearing === 2) return '48 hs';
  return 'NO';
};

export const formatCheckChpdLabel = (value?: string | null): string => {
  if (!value?.trim()) return '-';
  const normalized = value.trim().toLowerCase();
  if (normalized === 'cdp terceros') return 'Tercero';
  if (normalized === 'cdp propios') return 'Propio';
  return value.trim();
};

export const formatCheckAssetQuantity = (value: string | number | null | undefined): string => {
  if (value == null || value === '') return '-';
  const numeric = Number(String(value).replace(/\./g, '').replace(',', '.'));
  if (Number.isNaN(numeric)) return String(value);
  return numeric.toLocaleString('es-AR', {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  });
};

export const formatCheckAssetQuotation = (value: string | number | null | undefined): string => {
  if (value == null || value === '') return '-';
  const numeric = Number(String(value).replace(/\./g, '').replace(',', '.'));
  if (Number.isNaN(numeric)) return String(value);
  return numeric.toLocaleString('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  });
};
